<template>
  <div id="customer-payment">
    <div class="col-heading">
      <h3 class>
        Enter payment details
      </h3>
    </div>
    <div v-if="!paymentScriptLoaded">
      <small class="text--error">Initializing session...</small>
    </div>
    <template v-if="paymentScriptLoaded">
      <div class="form-group col-md-12 col-lg-10 col-xl-9 section__group">
        <div class="field">
          <div class="input input--checkbox group">
            <span class="proxy-label field__label">Terms and conditions</span>
            <input
              id="AcceptedTermsAndConditions"
              v-model="termsAndConditionsAccepted"
              type="checkbox"
              class="input__checkbox"
            >
            <label
              for="AcceptedTermsAndConditions"
              class="input__checkbox-input"
            >Customer has accepted the Terms &amp; Conditions</label>
          </div>
        </div>
      </div>
      <template v-if="activePaymentProvider === 'Braintree'">
        <div class="form-group col-md-12 col-lg-10 col-xl-9">
          <braintree-ui
            data-theme-label-mode="outside"
            ref="payment"
            data-enabled-payment-methods="[&quot;hosted-fields&quot;]"
            :data-amount="amount"
            :token="sessionId"
            :data-error-message="tokenizeError"
            :data-button-removed="!termsAndConditionsAccepted || disabled"
            @payload="handlePayload"
            @error="handleError"
          />
            <div v-if="disabled && !confirmFailed && !reserveInProgress" class="loader-wrapper">
                <p>Processing payment...</p>
            <svg
                id="loader-1"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="32px"
                height="32px"
                viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;"
                xml:space="preserve">
              <path
                  fill="#e71754"
                  d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                  transform="rotate(50.673 25 25)">
                <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.6s"
                    repeatCount="indefinite"/>
              </path>
            </svg>
            </div>
        </div>
        <button
          v-show="false"
          ref="formSubmitButton"
          type="button"
        />
      </template>
      <template v-else-if="activePaymentProvider === 'Paymentech'">
        <Message v-show="!termsAndConditionsAccepted" type="warning" message="Payment is disabled until terms and conditions have been accepted." />
        <paymentech-ui
            v-show="termsAndConditionsAccepted"
            ref="payment"
            v-bind:data-config="paymentechConfig"
            :data-amount="amount"
            @payload="handlePayload"
            @error="handleError"
          />
      </template>
      <template v-else>
        <Message type="error" message="No Payment provider could be detected, this could be a configurations issue, please contact the server admin." />
        <p><b></b></p>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VS2 from 'vue-script2'
import Message from '../../layout/Message';

export default {
    components: {
      Message
    },
    name: 'PaymentDetails',
    props: ['disabled', 'confirmFailed', 'reserveInProgress'],
    data () {
        return {
            termsAndConditionsAccepted: false,
            tokenizeError: null,
            paymentScriptLoaded: false,
            unsubscribe: null,
            activePaymentProvider: null,
            paymentechConfig: null
        }
    },
    computed: {
        ...mapState({
            sessionId: state => state.booking.bookingReserveResponse.data.sessionId,
            amount: state => state.booking.bookingReserveResponse.data.booking.price
        })
    },
    created () {
        // Load Shared Payments js Braintree/Paymentech
        VS2.load(
            'https://uicomponent.live.payments.maginfrastructure.com/payments.dev.js'
        ).then(() => {
            this.paymentScriptLoaded = true
            this.getSharedPaymentProvider();
            this.getToken();
        }).catch((err) => {
            this.$toasted.error(err)
        })
    },
    beforeDestroy () {
        if (this.unsubscribe) {
            this.unsubscribe()
        }
    },
    methods: {
        getSharedPaymentProvider () {
          var paymentConfig = this.$store.getters['getSpecificConfiguration']({
                section: 'PaymentConfigurations',
                identifier: this.$store.getters['getSelectedAirport'].code
            })

          if (paymentConfig.sharedPaymentProvider === "Paymentech") {
            this.activePaymentProvider = "Paymentech";
          } else if (paymentConfig.sharedPaymentProvider === "Braintree") {
            this.activePaymentProvider = "Braintree";
          } else {
            this.activePaymentProvider = null;
          }
        },
        getToken () {
            var paymentConfig = this.$store.getters['getSpecificConfiguration']({
                section: 'PaymentConfigurations',
                identifier: this.$store.getters['getSelectedAirport'].code
            })
            const paymentechEnviroment = (paymentConfig.environment).toLowerCase();
            this.paymentechConfig = JSON.stringify({'token': this.sessionId, 'environment': paymentechEnviroment});
        },
        handlePayload (e) {
            if (e.detail) {
                this.unsubscribe = this.$store.subscribe(this.bookingConfirmed)

                const paymentSession = {
                    sessionId: e.detail.nonce,
                    merchant: 'SharedPayment'
                }

                this.$store.dispatch('setPaymentSession', paymentSession)
            }
        },
        handleError (e) {
            this.tokenizeError = e.detail.message
        },
        bookingConfirmed (mutation, state) {
            if (mutation.type === 'setBookingConfirmResponse' || (mutation.type === 'setError' && mutation.payload)) {
                this.$refs.payment.dispatchEvent(new CustomEvent('complete', {
                    detail: {
                        success: true
                    }
                }))
            }
        }
    }
}
</script>

<style lang="scss">
  .paymentech-ui {
    .paymentech-ui-cvv-tooltip {
      background-color: rgba(118, 118, 121, 1);
    }
    .paymentech-ui-cvv-tooltip p {
      margin: 0;
    }
    iframe {
      border: 0;
    }
  }
</style>
